<template lang="html">
  <layout-public>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-form v-if="validToken">
              <v-card class="elevation-12" fill-height>
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Reset Password</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-text-field :error-messages="messages.email" v-model="emailAddress" prepend-icon="fa-envelope"
                    label="Email" type="text" required disabled></v-text-field>
                  <div class="password-container">
                    <v-text-field
                      v-model="password"
                      label="New Password"
                      :error-messages="messages.password"
                      :append-icon="showInput ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showInput ? 'text' : 'password'"
                      prepend-icon="fa-lock"
                      outlined
                      dense
                      hide-details="auto"
                      @click:append="toggleInputVisibility"
                      @input="checkPasswordStrength"
                    />
                    <div class="strength-indicator">
                      <div class="strength-bar" v-for="(segment, index) in 4" :key="index"
                        :class="getSegmentClass(index)"></div>
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                </v-card-text>
                <ul class="feedback-list">
                  <li :class="{ valid: validationCriteria.minLength, invalid: !validationCriteria.minLength }">
                    <span>{{ validationCriteria.minLength ? '✔' : '✖' }}</span>
                    Must be at least 8 characters.
                  </li>
                  <li
                    :class="{ valid: validationCriteria.hasNumberSymbol, invalid: !validationCriteria.hasNumberSymbol }">
                    <span>{{ validationCriteria.hasNumberSymbol ? '✔' : '✖' }}</span>
                    Must contain a number and symbol (allowed symbols:&nbsp;<b>@#$%^&+=!*()-</b>&nbsp;).
                  </li>
                  <li
                    :class="{ valid: validationCriteria.hasUpperLowerCase, invalid: !validationCriteria.hasUpperLowerCase }">
                    <span>{{ validationCriteria.hasUpperLowerCase ? '✔' : '✖' }}</span>
                    Must contain lowercase and uppercase letters.
                  </li>
                </ul>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <!-- <v-btn v-if="loading" loading></v-btn> -->
                  <v-btn color="dark-blue" class="mb-4 mr-3 add-course-button" :disabled="!isPasswordValid"
                    @click="reset">Reset Password</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </layout-public>
</template>

<script>
import LayoutPublic from '@/layouts/Public';
import authAPI from '@/api/auth.js';
export default {
  name: 'PasswordReset',
  components: {
    LayoutPublic,
  },
  data() {
    return {
      token: '',
      password: '',
      valid: true,
      messages: {
        email: [],
        password: [],
        error: [],
        loading: false,
      },
      validToken: this.$route.query.isResetPassword == 0 ? true : false,
      showInput: false,
      emailAddress: '',
      validationCriteria: {
        minLength: false,
        hasNumberSymbol: false,
        hasUpperLowerCase: false,
      },
      strengthLevel: 0, // Ranges from 0 to 4
      allowedSymbols: "@#$%^&+=!*()-", // Allowed symbols
      passwordLength: 8 // minimum char
    };
  },
  computed: {
    email: function () {
      return this.$route.query.email;
    },
    resetToken: function () {
      return this.$route.query.token;
    },
    isPasswordValid() {
      return Object.values(this.validationCriteria).every(Boolean);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // if(vm.$route.query.isResetPassword != 0) {
      // }
      vm.checkResetPasswordToken();
    });
  },
  watch: {
    password(newPassword) {
      this.validationCriteria.minLength = newPassword.length >= this.passwordLength;
      this.validationCriteria.hasNumberSymbol = /[0-9]/.test(newPassword) && /[!@#$%^&+=!*()-]/.test(newPassword);
      this.validationCriteria.hasUpperLowerCase = /[A-Z]/.test(newPassword) && /[a-z]/.test(newPassword);

      // Check for invalid symbols
      const invalidSymbols = newPassword
        .split("")
        .filter(
          (char) =>
            !/[a-zA-Z0-9]/.test(char) && !this.allowedSymbols.includes(char)
        );
      if (invalidSymbols.length > 0) {
        this.validationCriteria.hasNumberSymbol = false;
      }
    },
  },
  methods: {
    reset: function () {
      this.loading = true;
      let resetPassword = 1;
      if (this.$route.query.isResetPassword == 0) {
        resetPassword = 0;
      }
      authAPI
        .resetPassword(
          this.emailAddress,
          this.password,
          this.resetToken,
          resetPassword
        )
        .then(() => {
          this.$snotify.success('Password has been reset');
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
          this.getProfile();
          this.loading = false;
          this.$router.push('/login');
        })
        .catch((err) => {
          this.loading = false;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.$snotify.error(errMsg);
          }
          this.messages = this.$gf.errorResponse(err);
        });
    },
    getProfile() {
      this.$store
        .dispatch('profile')
        .then((resp) => {
          switch (this.$store.getters.level) {
            case 1:
              this.$router.push('/super-admin/companies');
              break;
            case 2:
              this.$router.push('/admin/users');
              break;
            case 4:
              this.$router.push('partner/users');
              break;
            case 5:
              this.$router.push('partner/users');
              break;
            case 6:
              this.$router.push('/super-admin/billinglist');
              break;
            case 7:
              this.$router.push('/courses');
              break;
            default:
              this.$router.push('/courses');
              break;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    checkResetPasswordToken() {
      authAPI
        .checkResetPasswordToken(this.email, this.resetToken)
        .then((response) => {
          this.validToken = true;
          this.emailAddress = response.data.email;
        })
        .catch((err) => {
          this.validToken = false;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.$snotify.error(errMsg);
            if (err.response.status == 422) {
              this.validToken = true;
            } else {
              this.validToken = false;
              this.$router.push('/login');
            }
          }
          this.messages = this.$gf.errorResponse(err);
        });
    },
    toggleInputVisibility() {
      this.showInput = !this.showInput;
    },
    checkPasswordStrength() {
      const criteria = [
        /.{8,}/, // At least 8 characters
        /[0-9]/, // Contains a number
        /[!@#$%^&+=!*()-]/, // Contains a symbol
        /(?=.*[a-z])(?=.*[A-Z])/, // Contains lowercase and uppercase letters
      ];

      // Calculate the strength level
      this.strengthLevel = criteria.reduce(
        (acc, regex) => (regex.test(this.password) ? acc + 1 : acc),
        0
      );
    },
    getSegmentClass(index) {
      if (index < this.strengthLevel) {
        if (this.strengthLevel <= 1) return "active-weak";
        if (this.strengthLevel === 2 || this.strengthLevel === 3)
          return "active-medium";
        return "active-strong";
      }
      return "";
    },
  },
};
</script>
<style scoped>
.feedback-list {
  margin-top: 10px;
  list-style-type: none;
  padding: 0;
  font-size: 14px;
  padding-left: 15px;
  list-style: none;
}

.feedback-list li {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.feedback-list li.valid {
  color: green;
}

.feedback-list li.invalid {
  color: red;
}

li {
  font-size: 14px;
  margin: 5px 0;
}

li span {
  font-weight: bold;
  margin-right: 8px;
}

.valid span {
  color: green; /* Tick color */
}

.invalid span {
  color: red; /* Cross color */
}

.password-container {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
}

.strength-indicator {
  display: flex;
  margin-top: 5px;
  gap: 2px;
  width: 50%;
}

.strength-bar {
  width: 20%;
  height: 8px;
  border-radius: 2px;
  background-color: #e0e0e0;
  /* Default color */
}

.strength-bar.active-weak {
  background-color: red;
}

.strength-bar.active-medium {
  background-color: orange;
}

.strength-bar.active-strong {
  background-color: green;
}
</style>